/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Min_DocsInputs */

const en_orders_min_docs = /** @type {(inputs: Orders_Min_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min docs`)
};

const es_orders_min_docs = /** @type {(inputs: Orders_Min_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs min`)
};

/**
* | output |
* | --- |
* | "Min docs" |
*
* @param {Orders_Min_DocsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_min_docs = /** @type {((inputs?: Orders_Min_DocsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Min_DocsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_min_docs(inputs)
	return es_orders_min_docs(inputs)
});